module.exports = __webpack_public_path__ + "static/media/app-v4-c.8c9832e7.jpg";